import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-390e6d4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"position":"relative","width":"100%","background":"rgba(var(--ion-color-primary-rgb), 0.25)","border-radius":"10px"},
  class: "range-bar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100px"} }, "Ihr Budget", -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_budget_big = _resolveComponent("budget-big")!
  const _component_budget_small = _resolveComponent("budget-small")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { style: {"font-size":"14px","padding-top":"70px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            class: "center-vert align-right",
            "size-xl": "3",
            size: "2",
            style: {"padding-left":"0"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.min/1000) + " € ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            "size-xl": "6",
            size: "7",
            class: "center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  style: _normalizeStyle(`left: calc(${_ctx.calcPercentageWish()}% - 35px)`),
                  class: "your-budget"
                }, _hoisted_3, 4),
                _createElementVNode("div", {
                  style: _normalizeStyle(`width: ${_ctx.calcPercentageWish()}%`),
                  class: "budget-line"
                }, null, 4),
                _createElementVNode("div", {
                  style: _normalizeStyle([`margin-left: ${_ctx.calcPercentageLow()}%; width: calc(${_ctx.calcPercentageHigh()}% - ${_ctx.calcPercentageLow()}%`, {"background":"var(--ion-headline-color)"}]),
                  class: "range-bar"
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle(`left: calc(${_ctx.calcPercentageWish()}% - 7px)`),
                    class: "min-pricebar"
                  }, null, 4)
                ], 4)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            class: "center-vert",
            "size-xl": "",
            size: "3",
            style: {"padding-right":"0"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.max/1000) + "k € ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.$route.name === 'EndPage')
        ? (_openBlock(), _createBlock(_component_budget_big, { key: 0 }))
        : (_openBlock(), _createBlock(_component_budget_small, { key: 1 }))
    ]),
    _: 1
  }))
}